var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "versions-layouts-wrapper" },
    [
      _c("div", { staticClass: "dbh-split-btn dbh-export-menu" }, [
        _c(
          "button",
          {
            staticClass: "dbh-btn dbh-btn--outline dbh-split-btn__main text-sm",
            attrs: { type: "button" },
            on: { click: _vm.openModal },
          },
          [
            _c("i", { staticClass: "bi bi-folder2-open" }),
            _vm._v("\n      Open\n    "),
          ]
        ),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "dbh-dropdown__panel dbh-export-menu__panel",
            attrs: { "data-display-builder-export-menu": "" },
          },
          [
            _c(
              "button",
              {
                staticClass: "new-menu-item text-sm",
                attrs: { type: "button" },
                on: { click: _vm.openNewVersionModal },
              },
              [
                _c("i", { staticClass: "bi bi-plus-lg mr-1" }),
                _vm._v("\n        New Version\n      "),
              ]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.showModal
          ? _c("div", {
              staticClass: "modal-backdrop-custom",
              on: {
                click: function ($event) {
                  if ($event.target !== $event.currentTarget) return null
                  return _vm.closeModal.apply(null, arguments)
                },
              },
            })
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-up" } }, [
        _vm.showModal
          ? _c(
              "div",
              {
                staticClass: "modal-custom",
                attrs: { role: "dialog", "aria-modal": "true" },
              },
              [
                _c("div", { staticClass: "modal-header-custom" }, [
                  _c("h5", { staticClass: "modal-title-custom" }, [
                    _vm._v("\n          Versions & Layouts\n        "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "show-details-btn",
                      attrs: { type: "button" },
                      on: { click: _vm.toggleDetails },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.showDetails ? "Hide details" : "Show details"
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "modal-close-btn",
                      attrs: { "aria-label": "Close", type: "button" },
                      on: { click: _vm.closeModal },
                    },
                    [_c("i", { staticClass: "bi bi-x-lg" })]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-tabs" }, [
                  _c(
                    "button",
                    {
                      staticClass: "tab-btn",
                      class: { active: _vm.activeTab === "versions" },
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          _vm.activeTab = "versions"
                        },
                      },
                    },
                    [
                      _vm._v("\n          Versions "),
                      _c("span", { staticClass: "tab-badge" }, [
                        _vm._v(_vm._s(_vm.versions.length)),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "tab-btn",
                      class: { active: _vm.activeTab === "layouts" },
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          _vm.activeTab = "layouts"
                        },
                      },
                    },
                    [
                      _vm._v("\n          Layouts "),
                      _c("span", { staticClass: "tab-badge" }, [
                        _vm._v(_vm._s(_vm.layouts.length)),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body-custom" }, [
                  _vm.activeTab === "versions"
                    ? _c(
                        "div",
                        [
                          _c("div", { staticClass: "list-header" }, [
                            _c("p", { staticClass: "tab-description mb-0" }, [
                              _vm._v(
                                "\n              Pick a Version to load, or create a new one.\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "dbh-btn dbh-btn--outline",
                                attrs: { type: "button" },
                                on: { click: _vm.openNewVersionModal },
                              },
                              [
                                _c("i", { staticClass: "bi bi-plus-lg" }),
                                _vm._v(
                                  "\n              New Version\n            "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.isLoading
                            ? _c(
                                "p",
                                { staticClass: "item-meta mt-4 text-center" },
                                [_vm._v("\n            Loading...\n          ")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.versions.length && !_vm.isLoading
                            ? _c(
                                "p",
                                { staticClass: "item-meta mt-4 text-center" },
                                [
                                  _vm._v(
                                    "\n            No versions saved yet.\n          "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isLoading && _vm.versions.length
                            ? _vm._l(_vm.versions, function (version) {
                                return _c(
                                  "div",
                                  {
                                    key: version.id,
                                    staticClass: "item-row",
                                    class: {
                                      selected: _vm.isCurrentVersion(version),
                                      "is-editing": _vm.isEditingItem(version),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleItemClick(version)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "item-grid-icon" },
                                      [
                                        _c("i", {
                                          class: _vm.isCurrentVersion(version)
                                            ? "bi bi-check-lg"
                                            : "bi bi-folder2-open",
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "item-info" }, [
                                      _vm.isEditingItem(version)
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.editingName,
                                                expression: "editingName",
                                              },
                                            ],
                                            staticClass: "item-name-input",
                                            attrs: {
                                              type: "text",
                                              maxlength: "255",
                                              "aria-label": `Rename ${version.name}`,
                                            },
                                            domProps: {
                                              value: _vm.editingName,
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                              },
                                              keydown: [
                                                function ($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  )
                                                    return null
                                                  $event.preventDefault()
                                                  $event.stopPropagation()
                                                  return _vm.saveRename(version)
                                                },
                                                function ($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "esc",
                                                      27,
                                                      $event.key,
                                                      ["Esc", "Escape"]
                                                    )
                                                  )
                                                    return null
                                                  $event.preventDefault()
                                                  $event.stopPropagation()
                                                  return _vm.cancelRename.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              ],
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.editingName =
                                                  $event.target.value
                                              },
                                            },
                                          })
                                        : _c(
                                            "span",
                                            { staticClass: "item-name" },
                                            [_vm._v(_vm._s(version.name))]
                                          ),
                                      _vm._v(" "),
                                      !_vm.isEditingItem(version)
                                        ? _c(
                                            "span",
                                            { staticClass: "item-meta" },
                                            [
                                              _vm._v(
                                                "\n                  Updated " +
                                                  _vm._s(
                                                    _vm.formatDate(
                                                      version.updatedAt
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.showDetails
                                        ? _c(
                                            "span",
                                            { staticClass: "item-meta" },
                                            [
                                              _vm._v(
                                                "\n                  Created by " +
                                                  _vm._s(
                                                    version.createdBy ||
                                                      "Unknown"
                                                  ) +
                                                  " - " +
                                                  _vm._s(
                                                    _vm.formatDate(
                                                      version.createdAt
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.showDetails
                                        ? _c(
                                            "span",
                                            { staticClass: "item-meta" },
                                            [
                                              _vm._v(
                                                "\n                  Last updated by " +
                                                  _vm._s(
                                                    version.updatedBy ||
                                                      "Unknown"
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "item-actions" },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "item-action-btn",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.loadItem(version)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Load\n                "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.isEditingItem(version)
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "item-action-btn item-action-btn--rename",
                                                attrs: {
                                                  type: "button",
                                                  "aria-label":
                                                    "Save version name",
                                                  title: "Save name",
                                                  disabled: _vm.isRenaming,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.saveRename(
                                                      version
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "bi bi-check-lg",
                                                }),
                                              ]
                                            )
                                          : _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "item-action-btn item-action-btn--rename",
                                                attrs: {
                                                  type: "button",
                                                  "aria-label":
                                                    "Rename version",
                                                  title: "Rename",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.startRename(
                                                      version
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "bi bi-pencil",
                                                }),
                                              ]
                                            ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "item-action-btn item-action-btn--danger",
                                            attrs: {
                                              type: "button",
                                              "aria-label": "Delete version",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.deleteItem(version)
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "bi bi-trash",
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              })
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.activeTab === "layouts"
                    ? _c(
                        "div",
                        [
                          _c("div", { staticClass: "list-header" }, [
                            _c("p", { staticClass: "tab-description mb-0" }, [
                              _vm._v(
                                "\n              Pick a Layout to load, or create a new one.\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "dbh-btn dbh-btn--outline",
                                attrs: { type: "button" },
                                on: { click: _vm.newLayout },
                              },
                              [
                                _c("i", { staticClass: "bi bi-plus-lg" }),
                                _vm._v(
                                  "\n              New Layout\n            "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.isLoading
                            ? _c("p", { staticClass: "item-meta" }, [
                                _vm._v("\n            Loading...\n          "),
                              ])
                            : !_vm.layouts.length
                            ? _c("p", { staticClass: "item-meta" }, [
                                _vm._v(
                                  "\n            No layouts saved yet.\n          "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.layouts, function (layout) {
                            return _c(
                              "div",
                              {
                                key: layout.id,
                                staticClass: "item-row",
                                class: {
                                  "is-editing": _vm.isEditingItem(layout),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleItemClick(layout)
                                  },
                                },
                              },
                              [
                                _c("span", { staticClass: "item-grid-icon" }, [
                                  _c("i", { staticClass: "bi bi-grid" }),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "item-info" }, [
                                  _vm.isEditingItem(layout)
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.editingName,
                                            expression: "editingName",
                                          },
                                        ],
                                        staticClass: "item-name-input",
                                        attrs: {
                                          type: "text",
                                          maxlength: "255",
                                          "aria-label": `Rename ${layout.name}`,
                                        },
                                        domProps: { value: _vm.editingName },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                          },
                                          keydown: [
                                            function ($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              )
                                                return null
                                              $event.preventDefault()
                                              $event.stopPropagation()
                                              return _vm.saveRename(layout)
                                            },
                                            function ($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "esc",
                                                  27,
                                                  $event.key,
                                                  ["Esc", "Escape"]
                                                )
                                              )
                                                return null
                                              $event.preventDefault()
                                              $event.stopPropagation()
                                              return _vm.cancelRename.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          ],
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.editingName =
                                              $event.target.value
                                          },
                                        },
                                      })
                                    : _c("span", { staticClass: "item-name" }, [
                                        _vm._v(_vm._s(layout.name)),
                                      ]),
                                  _vm._v(" "),
                                  !_vm.isEditingItem(layout)
                                    ? _c("span", { staticClass: "item-meta" }, [
                                        _vm._v(
                                          "\n                Updated " +
                                            _vm._s(
                                              _vm.formatDate(layout.updatedAt)
                                            ) +
                                            "\n              "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showDetails
                                    ? _c("span", { staticClass: "item-meta" }, [
                                        _vm._v(
                                          "\n                Created by " +
                                            _vm._s(
                                              layout.createdBy || "Unknown"
                                            ) +
                                            " - " +
                                            _vm._s(
                                              _vm.formatDate(layout.createdAt)
                                            ) +
                                            "\n              "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showDetails
                                    ? _c("span", { staticClass: "item-meta" }, [
                                        _vm._v(
                                          "\n                Last updated by " +
                                            _vm._s(
                                              layout.updatedBy || "Unknown"
                                            ) +
                                            "\n              "
                                        ),
                                      ])
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "item-actions" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "item-action-btn",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.loadItem(layout)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Apply\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.isEditingItem(layout)
                                    ? _c(
                                        "button",
                                        {
                                          staticClass:
                                            "item-action-btn item-action-btn--rename",
                                          attrs: {
                                            type: "button",
                                            "aria-label": "Save layout name",
                                            title: "Save name",
                                            disabled: _vm.isRenaming,
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.saveRename(layout)
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "bi bi-check-lg",
                                          }),
                                        ]
                                      )
                                    : _c(
                                        "button",
                                        {
                                          staticClass:
                                            "item-action-btn item-action-btn--rename",
                                          attrs: {
                                            type: "button",
                                            "aria-label": "Rename layout",
                                            title: "Rename",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.startRename(layout)
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "bi bi-pencil",
                                          }),
                                        ]
                                      ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "item-action-btn item-action-btn--danger",
                                      attrs: {
                                        type: "button",
                                        "aria-label": "Delete layout",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.deleteItem(layout)
                                        },
                                      },
                                    },
                                    [_c("i", { staticClass: "bi bi-trash" })]
                                  ),
                                ]),
                              ]
                            )
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                ]),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "dbh-btn dbh-btn--outline dbh-split-btn__caret",
        attrs: {
          type: "button",
          "aria-label": "More open options",
          "data-display-builder-export-toggle": "",
          "aria-expanded": "false",
        },
      },
      [_c("i", { staticClass: "bi bi-chevron-down" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }